import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <a href="mailto:Genentechsupport@pixacore.com" className="footer-link">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M3 4.5H15C15.825 4.5 16.5 5.175 16.5 6V12C16.5 12.825 15.825 13.5 15 13.5H3C2.175 13.5 1.5 12.825 1.5 12V6C1.5 5.175 2.175 4.5 3 4.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16.5 6L9 9.75L1.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Contact Support
        </a>
        <p className="footer-copyright">
          &copy; {currentYear} Genentech USA, Inc. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
